import { gradeContentsMap } from '@components/phs/pst/results/result/gradeInfo/data';
import { gradeTextSelectMap, GradeType } from '@domain/constant/gradeType';
import { Version, VersionType } from '@domain/constant/phs/result/versionType';
import classnames from 'classnames/bind';
import styles from './achievementGrade.module.scss';
const cx = classnames.bind(styles);

interface AchievementGradeProps {
  version: VersionType;
  grade: GradeType;
}

const AchievementGrade = ({ version, grade }: AchievementGradeProps) => {
  const contents = gradeContentsMap[grade];

  const getProblemDescEl = () => {
    if (version === Version.V1) return null;
    return <p className={cx('desc')}>{contents.problemDesc}</p>;
  };

  return (
    <div className={cx('cardInner')}>
      <img className={cx('gradeImg')} src={contents.imgSrc} alt={'등급 이미지'} />
      <p className={cx('title')}>
        <em className={cx('grade', grade)}>{gradeTextSelectMap[grade]}</em> 등급을 달성하였습니다.
      </p>
      <p className={cx('desc', 'em')}>{contents.gradeDesc}</p>
      {getProblemDescEl()}
      <p className={cx('desc')}>{contents.abilityDesc}</p>
      <p className={cx('desc')}>{contents.recruitmentsDesc}</p>
      <p className={cx('desc')}>{contents.nextTimeDesc}</p>
    </div>
  );
};

export default AchievementGrade;
